import { newUserPassword } from '../services/accountService'

function fetchNewPassword(data) {
  return () => newUserPassword(data)
}

export default fetchNewPassword
